// ThingsToDo.js
import React, { useState } from 'react';
import './ThingsTodo.css';
import {  AnimatePresence } from 'framer-motion';
import {
  Container,
  Title,
  ButtonContainer,
  CategoryButton,
  ImageGrid,
  ImageCard
} from './ThingsToDo.styles.js';
import historic1 from '../../../Assets/Image/things-todo/20.jpg';
import historic2 from '../../../Assets/Image/things-todo/caption (13).jpg';
import historic3 from '../../../Assets/Image/things-todo/61.jpg';
import historic4 from '../../../Assets/Image/things-todo/caption (11).jpg';
import historic5 from '../../../Assets/Image/things-todo/15.jpg';
import historic6 from '../../../Assets/Image/things-todo/1e.jpg';
import historic7 from '../../../Assets/Image/things-todo/caption (10).jpg';
import historic8 from '../../../Assets/Image/things-todo/caption (3).jpg';
import historic9 from '../../../Assets/Image/things-todo/doho.jpg';
import historic10 from '../../../Assets/Image/things-todo/caption (1).jpg';


import nature1 from '../../../Assets/Image/things-todo/caption (12).jpg';
import nature2 from '../../../Assets/Image/things-todo/caption (5).jpg';
import nature3 from '../../../Assets/Image/things-todo/caption (6).jpg';
import nature4 from '../../../Assets/Image/things-todo/caption2.jpg';
import nature5 from '../../../Assets/Image/things-todo/caption (3).jpg';
import nature6 from '../../../Assets/Image/things-todo/yangudi.jpg';
import nature7 from '../../../Assets/Image/things-todo/sulphur.jpg';
import nature8 from '../../../Assets/Image/things-todo/26hadar2009_656.jpg';


import cultural1 from '../../../Assets/Image/things-todo/caption (4).jpg';
import cultural2 from '../../../Assets/Image/things-todo/caption (5).jpg';
import cultural3 from '../../../Assets/Image/things-todo/caption.jpg';
import cultural4 from '../../../Assets/Image/things-todo/caption (6).jpg';
import cultural5 from '../../../Assets/Image/things-todo/caption4.jpg';
import cultural6 from '../../../Assets/Image/things-todo/danakil-depression-2.jpg';
import cultural7 from '../../../Assets/Image/things-todo/danakil-depression-2 (4).jpg';
import cultural8 from '../../../Assets/Image/things-todo/danakil-depression-2 (3).jpg';


import wildlife1 from '../../../Assets/Image/things-todo/caption (9).jpg';
import wildlife2 from '../../../Assets/Image/things-todo/caption (7).jpg';
import wildlife3 from '../../../Assets/Image/things-todo/images (1).jpg';
import wildlife4 from '../../../Assets/Image/things-todo/caption (8).jpg';
import wildlife5 from '../../../Assets/Image/things-todo/images (3).jpg';
import wildlife6 from '../../../Assets/Image/things-todo/excavation-cave.jpg';
import wildlife7 from '../../../Assets/Image/things-todo/images (2).jpg';
import wildlife8 from '../../../Assets/Image/things-todo/images.jpg';

// Import images (you'll need to replace these with your actual image paths)
const historicImages = [
  historic1,
  historic2,
  historic3,
  historic4,
  historic5,
  historic6,
  historic7,
  historic8,
  historic9,
  historic10,
  // ... add all 10 images
];

const natureImages = [
  nature1,
  nature2,
  nature3,
  nature4,
  nature5,
  nature6,
  nature7,
  nature8,
];

const culturalImages = [
  cultural1,
  cultural2,
  cultural3,
  cultural4,
  cultural5,
  cultural6,
  cultural7,
  cultural8,

];

const wildlifeImages = [
  wildlife1,
  wildlife2,
  wildlife3,
  wildlife4,
  wildlife5,
  wildlife6,
  wildlife7,
  wildlife8,
];

const ThingsToDo = () => {
  const [activeCategory, setActiveCategory] = useState(null);

  const getImages = (category) => {
    switch (category) {
      case 'historic':
        return historicImages;
      case 'nature':
        return natureImages;
      case 'cultural':
        return culturalImages;
      case 'wildlife':
        return wildlifeImages;
      default:
        return [];
    }
  };

  return (
    <Container>
      <Title>Things to Do in Afar Region</Title>
      <ButtonContainer>
        <CategoryButton
          whileTap={{ scale: 0.95 }}
          className={activeCategory === 'historic' ? 'active' : ''}
          onClick={() => setActiveCategory(activeCategory === 'historic' ? null : 'historic')}
        >
          Explore Historic Sites
        </CategoryButton>
        <CategoryButton
          whileTap={{ scale: 0.95 }}
          className={activeCategory === 'nature' ? 'active' : ''}
          onClick={() => setActiveCategory(activeCategory === 'nature' ? null : 'nature')}
        >
          Adventure in Nature
        </CategoryButton>
        <CategoryButton
          whileTap={{ scale: 0.95 }}
          className={activeCategory === 'cultural' ? 'active' : ''}
          onClick={() => setActiveCategory(activeCategory === 'cultural' ? null : 'cultural')}
        >
          Cultural Experiences
        </CategoryButton>
        <CategoryButton
          whileTap={{ scale: 0.95 }}
          className={activeCategory === 'wildlife' ? 'active' : ''}
          onClick={() => setActiveCategory(activeCategory === 'wildlife' ? null : 'wildlife')}
        >
          Wildlife and Eco-Tours
        </CategoryButton>
      </ButtonContainer>

      <AnimatePresence mode="wait">
        {activeCategory && (
          <ImageGrid
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
          >
            {getImages(activeCategory).map((image, index) => (
              <ImageCard
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ delay: index * 0.1 }}
              >
                <img src={image} alt={`${activeCategory} ${index + 1}`} />
              </ImageCard>
            ))}
          </ImageGrid>
        )}
      </AnimatePresence>
    </Container>
  );
};

export default ThingsToDo;